/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const usePriceHikeInfo = (
  goalUID,
  options = { selector: null, fallbackData: undefined }
) => {
  const key = 'active-price-hikes';
  const {
    data: priceHikeInfo,
    isValidating,
    ...rest
  } = useFetch(
    key,
    { hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );

  if (goalUID) {
    return priceHikeInfo?.find?.((priceHikeObj) => {
      const priceHikeGoals = priceHikeObj.activeGoals?.split(',');
      return (
        priceHikeObj.isActive &&
        new Date(priceHikeObj.expiryDate) >= new Date() &&
        priceHikeGoals?.includes(goalUID)
      );
    });
  }
  if (options.selector && typeof options.selector === 'function')
    return options.selector(priceHikeInfo || {});
  return {
    key,
    priceHikeInfo,
    isValidating,
    ...rest
  };
};

export default usePriceHikeInfo;
